import { Box, Typography } from '@mui/material'
import PrimaryButton from '../common/PrimaryButton'
import HomeStoryCard from '../home/HomeStoryCard'
import { storiesPageItems } from '../../data/storiesContent'
import { sectionHeadingSx } from '../../theme/mobileLayout'

export default function StoryRelatedStories() {
  return (
    <Box
      component="section"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: 5, md: '80px' },
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', sm: 'center' },
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: 3, sm: 2 },
          width: '100%',
        }}
      >
        <Typography component="h2" sx={sectionHeadingSx}>
          Latest Stories
        </Typography>
        <PrimaryButton to="/stories" showArrow={false}>
          See All Stories
        </PrimaryButton>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            lg: 'repeat(3, 1fr)',
          },
          gap: { xs: 5, md: '40px' },
          alignItems: 'start',
        }}
      >
        {storiesPageItems.map((story) => (
          <HomeStoryCard
            key={story.slug}
            title={story.title}
            date={story.date}
            image={story.image}
            to={`/stories/${story.slug}`}
          />
        ))}
      </Box>
    </Box>
  )
}
